<template>
    <v-dialog v-model="isShowDialog" persistent max-width="50rem">
        <v-card>
            <v-card-title class="secondary elevation-4 white--text">
                <div class="text-h5">
                    <v-icon class="pb-1" color="white" medium> add </v-icon>
                    {{ $t('Multifactor_Authenticate_Device_Setting') }}
                </div>
            </v-card-title>
            <v-window v-model="step" class="pa-3">
                <v-window-item :value="1">
                    <card-register-confirmation
                        :is-processing="isProcessing"
                        @register="deviceRegister"
                        @closeDialog="closeDialog"
                    />
                </v-window-item>
                <v-window-item :value="2">
                    <card-qrcode-description
                        :uid="user.uid"
                        :secret="auth.softRegistered.secret_key"
                        @readComplete="readComplete"
                    />
                </v-window-item>
                <v-window-item :value="3">
                    <card-register-completion
                        @closeDialog="closeDialog"
                        @returnQrcodeDescription="returnQrcodeDescription"
                    />
                </v-window-item>
            </v-window>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { CardQrcodeDescription, CardRegisterCompletion, CardRegisterConfirmation } from '../../molecules';
import type { AuthState } from '../../../store/modules/auth/types';
import { State } from 'vuex-class';

const namespace = 'auth';

@Component({
    name: 'TheSoftDeviceRegisterDialog',
    components: {
        CardQrcodeDescription,
        CardRegisterCompletion,
        CardRegisterConfirmation,
    },
})
export default class TheSoftDeviceRegisterDialog extends Vue {
    @Prop({ default: false }) isShow: boolean;
    @Prop({ default: () => {} }) user: { uid: string; password: string };
    @State('auth') auth: AuthState;
    @Action('softDeviceRegister', { namespace }) softDeviceRegister;
    @Action('softDeviceRegisterReset', { namespace }) softDeviceRegisterReset;
    @Watch('isShow')
    async onIsShowDialogChanged(val: boolean) {
        if (val) {
            this.step = 1;
            await this.softDeviceRegisterReset();
        }
    }

    step = 1;

    /**
     * getter, setter
     */
    get userData(): { uid: string; password: string } {
        return this.user;
    }
    get isShowDialog(): boolean {
        if (this.auth.softRegistered.error) {
            return false;
        } else {
            return this.isShow;
        }
    }
    set isShowDialog(newVal: boolean) {
        this.closeDialog();
    }
    get isProcessing(): boolean {
        return this.auth.softRegistered.isProcessing;
    }

    /**
     * methods
     */
    closeDialog(): void {
        this.$emit('cancel-dialog');
    }
    // SoftDevice登録処理
    async deviceRegister() {
        await this.softDeviceRegister(this.userData);
        if (!this.auth.softRegistered.error) {
            this.step++;
            this.unloadWarningDisplay();
        } else {
            this.closeDialog();
        }
    }
    // QRコード読み込み完了
    readComplete(): void {
        this.unloadWarningCancel();
        this.step++;
    }

    // QRコード表示中は画面遷移時に確認ダイアログを表示する
    unloadWarningDisplay(): void {
        window.addEventListener('beforeunload', this.unloadMessage);
    }
    unloadWarningCancel(): void {
        window.removeEventListener('beforeunload', this.unloadMessage);
    }
    // 個別メッセージは表示しない
    unloadMessage(e): void {
        e.returnValue = '';
    }
    // QRコード表示に戻る
    returnQrcodeDescription(): void {
        this.step--;
    }
}
</script>
